module.exports = __webpack_public_path__ + "img/montreal-city-bus-wifi.95046470.webp";